export { setComponentColor } from './set-component-color'
